




























































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationListPrint extends ApiAccessBase {

  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE + '/applist/';
  private printList: string[] = [];

  private created() {
    this.screenTitle = '申請内容一覧';

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);
    let path = this.APP_PATH;
    path = path + applicationFormModule.GET_TRADER_ID;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        this.checkAll();
      }
    });
  }
  private checkAll() {
    // ディープコピー
    this.printList = JSON.parse(JSON.stringify(this.formData.localGovernmentKikanNo));
  }
  private checkOffAll() {
    this.printList = [];
  }
  /**
   * 申請内容一覧出力
   */
  private print() {
    let queryParam = '?';
    let queryCount = 0;
    for (const kikanNo of this.printList) {
      if (kikanNo !== undefined && kikanNo !== null) {
        queryParam += '&localGovernmentKikanNo=' + kikanNo;
        queryCount++;
      }
    }
    if (queryCount === 0) {
      alert('出力対象が選択されていません。');
      return;
    }

    let path = this.APP_PATH;
    // ボタン押下時
    // if (window.confirm(Message.I0021)) {
    path = path + 'print/' + applicationFormModule.GET_TRADER_ID + queryParam;
    this.apiAccessDownload(path);
    // }
  }
  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    //20241118 [appListPrint++] a-matsui upd start
    //if (applicationFormModule.GET_CHANGE_TYPE === '1') {
    //  router.push('appFormConfirmChange');
    //} else {
    //  router.push('appFormConfirm');
    //}
    router.push('appForm');
    //20241118 [appListPrint++] a-matsui upd end
  }
}
